import Cookies from 'js-cookie';
import findDomain from './findDomain';
import countryRedirect from './countryRedirect';

export default (country_code = 'US') => {  
  const domain = findDomain(country_code);
  
  if (window.location.hostname !== domain && !Cookies.get('region_ignore')) {
    countryRedirect(country_code, true);
  }

}; 
